import { Animation } from "./animations";

//
// Spustíme skripty, které mohou být součástí nově vkládaného obsahu.
// (musíme vytvořit novou script značku, překopírovat do ní obsah a vložit do dokumentu,
// tím se skript spustí)
//
function runScripts(parent) {
	var scripts = parent.querySelectorAll("script");
	for (var i = 0; i < scripts.length; ++i) {
		var script = scripts[i];
		var newScript = document.createElement("script");

		newScript.appendChild(document.createTextNode(script.innerHTML));
		script.parentNode.replaceChild(newScript, script);
	}
}

//
// Vymění obsah elementu za nový obsah.
//
// Nahrazení obsahu ještě vylepšíme o možnost některý obsah zachovat, což v tuto
// chvíli znamená zachování hodnot formulářových polí a tříd u elementů, které jsou označeny
// atributem data-snippet-preserve="unikátní identifikátor". Jsou-li identifikátory
// shodné ve starém i novém obsahu, nastaví se do formulářových polí původní
// hodnoty, případně třídy na elementech.
//
function replaceContent(parent, content) {
	// Nahradíme snippet novým obsahem.
	parent.innerHTML = content;

	runScripts(parent);

	// Informujeme okolí, že snippet byl nahrazen novým obsahem.
	parent.trigger("snippetready", { parent: parent }, true);
}


//
// Vymění obsah elementu za nový obsah pomocí fade animace.
//
function replaceContentUsingFade(parent, content) {
	Animation.fadeOut(parent, true).then(function() {
		// Nyní, jakmile se spustí tento callback, obsah není vidět.
		// Můžeme proto obsah nyní nahradit.
		replaceContent(parent, content);

		// A po nahrazení obsahu opět snippet zobrazíme pomocí animace.
		Animation.fadeIn(parent);
	});
}


//
// Přidá nový obsah k existujicímu.
//
function appendContent(parent, content, isAnimated) {
	isAnimated = isAnimated || false;

	var dummy = document.createElement("div");
	dummy.innerHTML = content;

	runScripts(dummy);

	var elements = [];
	for (var i = 0; i < dummy.children.length; ++i) {
		var element = dummy.children[i];
		if (isAnimated) {
			element.style.visibility = "hidden";
		}
		parent.appendChild(element);
		elements.push(element);
	}

	if (isAnimated) {
		Animation.fadeIn(elements);
	}
}

//
// Přidá obsah elementu za starý obsah pomocí fade animace.
//
function appendContentUsingFade(parent, content) {
	appendContent(parent, content, true);
}

//
// Aktualizuje snippet.
//
// Pozor, nevyužíváme zde jQuery jako originální Nette knihovna, proto
// snippety po přidání nespouští případný javascriptový kód uzavřený ve "script"
// tagách. Tuto funkcionalitu poskytuje navíc jQuery. Na druhou stranu způsob
// spouštění javascriptu takto ve snippetech neznačí z návrhového pohledu nic
// dobrého a tedy by se vždy měla najít jiná cesta než patčiný "eval()" doplnit
// do této funkce.
//
function updateSnippet(snippetId, content) {
	// Nejprve najdeme kontejneru snippetu.
	var elements = document.querySelectorAll("#snippet-" + snippetId + ", .snippet-" + snippetId);
	for (var i = 0; i < elements.length; ++i) {
		var element = elements[i];

		var options = (element.getAttribute("data-snippet") || "").split(/\s+/);
		var isAnimated = options.includes("fade");
		var isAppend = options.includes("append");

		// Naše rozšíření snippetů má možnost nový obsah prolnout.
		if (isAnimated) {
			if (isAppend) {
				appendContentUsingFade(element, content);
			}
			else {
				replaceContentUsingFade(element, content);
			}
		}
		else {
			// Obyčejné nahrazení obsahu bez animace.
			if (isAppend) {
				appendContent(element, content);
			}
			else {
				replaceContent(element, content);
			}
		}
	}
}


//
// Jakmile v AJAXovém požadavku objevíme pole "snippets", tak jej interpretujeme
// jako Nette snippety a nahradíme jimi patřičná místa v HTML kódu.
//
document.addEventListener("ajaxsuccess", function(event) {
	var responseJSON = event.detail.responseJSON;
	if (responseJSON && responseJSON.snippets) {
		for (var key in responseJSON.snippets) {
			updateSnippet(key, responseJSON.snippets[key]);
		}
	}
});
